import React from 'react';
import { motion } from 'framer-motion';
import { SectionMarker } from './SectionMarker';
import { BookMockup } from './BookMockup';
export function MethodSection() {
  const methodSteps = [{
    number: 1,
    title: 'Descarga mental guiada',
    description: 'Para que lo que no procesas de día no te visite de noche.'
  }, {
    number: 2,
    title: 'Respiración reguladora',
    description: 'Para activar el sistema de descanso real.'
  }, {
    number: 3,
    title: 'Preparación corporal estratégica',
    description: 'Para liberar tensión acumulada.'
  }, {
    number: 4,
    title: 'Protocolo 2–3 AM',
    description: 'Qué hacer exactamente cuando despiertas.'
  }];
  return <section className="w-full bg-navy-darkest py-10 md:py-14" data-id="element-177">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-179">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-180">
            <SectionMarker data-id="element-181" />
            <span className="text-cream-muted text-sm uppercase tracking-wider" data-id="element-182">
              Presentación del método
            </span>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-183">
          {/* Product Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex justify-center" data-id="element-184">
            <img src="https://cdn.magicpatterns.com/uploads/s9nvneso455ivduwzP1Xvp/imagen_del_bono0_(1)_(1).jpg" alt="Mujer relajada con tablet — Método de 21 Noches" className="w-full max-w-sm object-cover rounded-xl drop-shadow-xl" data-id="element-185" />
          </motion.div>

          {/* Content */}
          <div data-id="element-186">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-187">
              <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-6 text-center" data-id="element-188">
                El Método de 21 Noches
              </h2>

              {/* QUÉ INCLUYE */}
              <div className="mb-8 p-6 bg-navy-dark/50 border border-cream-muted/10 rounded-lg" data-id="element-189">
                <h3 className="font-playfair text-xl md:text-2xl font-bold text-amber mb-4 text-center uppercase tracking-wider" data-id="element-190">
                  Qué incluye
                </h3>
                <div className="space-y-3 text-cream-muted" data-id="element-191">
                  <p className="flex items-center gap-2" data-id="element-192">
                    <span className="text-teal-check" data-id="element-193">✔</span> Ebook completo
                  </p>
                  <p className="flex items-center gap-2" data-id="element-194">
                    <span className="text-teal-check" data-id="element-195">✔</span> Audios guiados
                  </p>
                  <p className="flex items-center gap-2" data-id="element-196">
                    <span className="text-teal-check" data-id="element-197">✔</span> Plantillas
                    descargables
                  </p>
                  <p className="flex items-center gap-2" data-id="element-198">
                    <span className="text-teal-check" data-id="element-199">✔</span> Calendario de 21
                    noches
                  </p>
                </div>
              </div>

              <p className="text-lg text-cream-muted leading-relaxed mb-8" data-id="element-200">
                Un protocolo práctico diseñado para reentrenar tu sistema
                nervioso de forma progresiva.
              </p>

              <p className="text-cream mb-8" data-id="element-201">
                No es teoría. No es motivación. No es espiritualidad vaga.
              </p>

              <p className="text-xl text-amber font-medium mb-10" data-id="element-202">
                Es estructura.
              </p>
            </motion.div>

            <p className="text-cream-muted mb-6" data-id="element-203">
              Durante 21 noches aprenderás:
            </p>

            <div className="space-y-6" data-id="element-204">
              {methodSteps.map((step, index) => <motion.div key={step.number} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1 * index
            }} className="flex items-start gap-4" data-id="element-205">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-amber text-navy-darkest font-bold flex items-center justify-center text-sm" data-id="element-206">
                    {step.number}
                  </span>
                  <div data-id="element-207">
                    <h3 className="text-lg font-semibold text-cream mb-1" data-id="element-208">
                      {step.title}
                    </h3>
                    <p className="text-cream-muted" data-id="element-209">{step.description}</p>
                  </div>
                </motion.div>)}
            </div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="mt-10 font-playfair text-xl italic text-amber" data-id="element-210">
              Sin culpa. Sin lucha interna. Sin pánico.
            </motion.p>
          </div>
        </div>
      </div>
    </section>;
}